// Banco de imagens ilustrativas por tipo de equipamento.
const BASE = "/equip";

export function equipmentImage(type = "") {
  const t = (type || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
  if (!t) return null;
  if (t.includes("condens") || t.includes("externa")) return `${BASE}/condensadora.jpg`;
  if (t.includes("multi")) {
    if (t.includes("3") || t.includes("tri")) return `${BASE}/multisplit_3.jpg`;
    return `${BASE}/multisplit_2.jpg`;
  }
  if (t.includes("inverter")) return `${BASE}/split_inverter.jpg`;
  if (t.includes("cassete") || t.includes("k7")) return `${BASE}/cassete_k7.jpg`;
  if (t.includes("piso")) return `${BASE}/piso_teto.jpg`;
  if (t.includes("janela")) return `${BASE}/janela.jpg`;
  if (t.includes("comercial")) return `${BASE}/comercial.jpg`;
  if (t.includes("gelad") || t.includes("freezer")) return `${BASE}/geladeira.jpg`;
  if (t.includes("lav") || t.includes("secad")) return `${BASE}/lavadora.jpg`;
  if (t.includes("hi-wall") || t.includes("hiwall") || t.includes("hi wall") ||
      t.includes("multi") || t.includes("split") || t.includes("ar") || t.includes("condicionado")) {
    return `${BASE}/split_hiwall.jpg`;
  }
  return null;
}
